// Invisible padding that takes a control's hit area out to the 44px touch
// minimum without changing what it looks like, so the board's fixed geometry
// (and the skeleton that mirrors it) stays put. Touch layouts only: on a
// pointer surface the phantom zone would show a hand cursor over nothing.
export const TOUCH_TARGET = 44;

export const touchHitAreaSx = (visibleHeight: number) => {
  const reach = Math.max(0, (TOUCH_TARGET - visibleHeight) / 2);
  return {
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      top: -reach,
      bottom: -reach,
    },
  } as const;
};
